export const REPORT_TYPE_TOOLTIPS = {
  buy: 'Analyze the profitability of purchasing a property as a short-term rental investment.',
  rent: 'Evaluate the potential earnings from Airbnb arbitrage opportunities.',
  manage: 'Estimate the revenue for managing your existing property as an Airbnb listing.',
};
